import { ImageField, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  ImagePropertiesParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type C15ImageAssetProps = RenderingProps<
  {
    Image?: ImageField;
    Caption?: RichTextField;
    ImageCTALink?: LinkField;
    MobileImage?: ImageField;
  },
  {
    ImageAlignment?: string;
    ImageBorderOn?: string;
  } & TranslationOptionsParams &
    AnchorTargetParams &
    ImagePropertiesParams
>;
